import React from 'react';

import '../assets/css/loading.css';

const Loading = () => {
    return (
            <div className='loading-bg'>
                <div className="loading" data-loading-text="USMLSA"></div>
            </div>
    )
}

export default Loading;
